import { render } from "./FellowShipCard.vue?vue&type=template&id=ed906b24&scoped=true"
import script from "./FellowShipCard.vue?vue&type=script&lang=js"
export * from "./FellowShipCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed906b24"]])

export default __exports__